"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }/* The web Templates dialog and mobile's Settings → Templates: loads the org's templates and the
 * recently deleted ones, and deletes (with Undo), restores and duplicates.
 * Who may do what is the server's call (CanEdit, CanManage); this only acts
 * and says what happened through the platform's notices. */
var _react = require('react');



var _messageTemplate = require('shared/actions/messageTemplate'); var _messageTemplate2 = _interopRequireDefault(_messageTemplate);
var _messageTemplate3 = require('shared/selectors/messageTemplate');
var _templateEditing = require('shared/services/templateEditing');
var _templateList = require('shared/services/templateList');
var _typed = require('shared/hooks/typed');






 const useTemplateManagement = (orgKey, notices) => {
  const templates = _typed.useAppSelector.call(void 0, state => _messageTemplate3.selectMessageTemplates.call(void 0, state, orgKey))
  const [isLoading, setIsLoading] = _react.useState.call(void 0, true)
  // Deleted in the last 30 days and restorable by me; the server decides.
  const [recentlyDeleted, setRecentlyDeleted] = _react.useState([])
  // The template just deleted, while its Undo is on screen.
  const [undoable, setUndoable] = _react.useState(null)
  const undoTimer = _react.useRef(null)
  const notify = _react.useRef.call(void 0, notices)
  notify.current = notices

  const loadRecentlyDeleted = _react.useCallback.call(void 0, () => {
    _messageTemplate2.default.listDeletedMessageTemplates(orgKey)
      .then(({ Templates }) => setRecentlyDeleted(Templates))
      .catch(() => null)
  }, [orgKey])

  _react.useEffect.call(void 0, () => {
    _messageTemplate2.default.listMessageTemplates(orgKey)
      .catch(() => notify.current.warning("Couldn't load templates. Please try again."))
      .finally(() => setIsLoading(false))
    loadRecentlyDeleted()
  }, [orgKey, loadRecentlyDeleted])

  _react.useEffect.call(void 0, () => () => { if (undoTimer.current) clearTimeout(undoTimer.current) }, [])

  const duplicate = _react.useCallback.call(void 0, (t) => {
    _messageTemplate2.default.createMessageTemplate(orgKey, { Scope: 'private', Name: t.Name, Body: t.Body })
      .then(() => notify.current.success(`Copied "${t.Name}" to Mine`))
      .catch(e => notify.current.warning(_templateEditing.saveErrorMessage.call(void 0, e)))
  }, [orgKey])

  const remove = _react.useCallback.call(void 0, (t) => {
    _messageTemplate2.default.deleteMessageTemplate(orgKey, t.TemplateKey)
      .then(() => {
        if (undoTimer.current) clearTimeout(undoTimer.current)
        setUndoable(t)
        undoTimer.current = setTimeout(() => setUndoable(null), _templateList.UNDO_TOAST_MS)
        loadRecentlyDeleted()
      })
      .catch(e => notify.current.warning(_templateEditing.saveErrorMessage.call(void 0, e)))
  }, [orgKey, loadRecentlyDeleted])

  const restore = _react.useCallback.call(void 0, (t) => {
    if (undoTimer.current) clearTimeout(undoTimer.current)
    setUndoable(null)
    _messageTemplate2.default.restoreMessageTemplate(orgKey, t.TemplateKey)
      .then(() => {
        notify.current.success(`Restored "${t.Name}"`)
        setRecentlyDeleted(list => list.filter(d => d.TemplateKey !== t.TemplateKey))
      })
      .catch(e => notify.current.warning(_templateEditing.saveErrorMessage.call(void 0, e)))
  }, [orgKey])

  return { templates, isLoading, recentlyDeleted, loadRecentlyDeleted, undoable, duplicate, remove, restore }
}; exports.useTemplateManagement = useTemplateManagement
